<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-job-audit-presenter
    [items]="JobAuditModel$ | async"
    [loading]="JobAuditModelDS.loading$ | async"
    (DateFiltersChanged)="onDateFiltersChanged($event)"
></ef-job-audit-presenter>
